export const PoemTheScripture = () => {
    return (
        <div id="038" className="">
            <p>i've figured out life.</p>
            <p>everything that you do has to be in defiance</p>
            <p>of what God has given to you. </p>
            <p>nature/nurture falling dominoes situation.</p>
            <p>the path is ridden with obstacles that will end your path,</p>
            <p>planet-sized feedback loop,</p>
            <p>
                a seed of doubt has this tendency of growing into an entire
                orchard.
            </p>
            <p>does art ever stop touching your heart?</p>
            <p>i just want to gorge on the fruits, to be honest.</p>
            <p>a myriad of opportunities line themselves up</p>
            <p>so you can reject them one by one.</p>
            <p>what's better than a 7 out of 10? trust me, nothing.</p>
            <p>the more you rewrite the words, the further away it feels,</p>
            <p>if i had to choose between knowledge and blissful ignorance,</p>
            <p>it's bliss every time.</p>
            <p>winning something is the seed</p>
            <p>of the eventual fear of losing the thing,</p>
            <p>so drop the gold ring in the sewer grate,</p>
            <p>all the pride that i have ever felt in my life</p>
            <p>is just</p>
            <p>whipped cream and chocolate syrup.</p>
            <p>for thousands of years the sin was always</p>
            <p>
                not trying to find the root of the thing growing thorns in your
                guts.
            </p>
            <p>and at the end of the world</p>
            <p>the sky is going to be a pale pastel pink,</p>
            <p>and the crowds of people will complain that it's not</p>
            <p>what they envisioned it to be,</p>
            <p>it's only human nature.</p>
        </div>
    );
};
